import { useCallback } from "react";

/**
 * Custom floating launcher for the built-in AI assistant.
 * The default widget button is hidden globally, and this branded
 * AI button triggers it instead.
 */
export default function AgentLauncher() {
  const openAssistant = useCallback(() => {
    const trigger = document.querySelector<HTMLElement>("#vapi-widget-floating-button");
    if (trigger) {
      trigger.click();
    }
  }, []);

  return (
    <button
      type="button"
      onClick={openAssistant}
      aria-label="Open the KAL LORDS ZERO21 DJT AI assistant"
      className="group fixed bottom-5 right-5 z-[60] flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-primary-400/50 bg-foreground-950 text-primary-300 transition-transform duration-200 hover:scale-105 hover:text-accent-400 md:bottom-6 md:right-6 md:h-16 md:w-16"
      style={{ boxShadow: "0 8px 24px rgba(0, 0, 0, 0.28)" }}
    >
      <span className="pointer-events-none absolute inset-0 rounded-full bg-primary-500/10" aria-hidden="true" />
      <i className="ri-sparkling-2-line text-2xl md:text-3xl" aria-hidden="true" />
      <span className="pointer-events-none absolute -top-0.5 -right-0.5 h-3 w-3 rounded-full bg-accent-400" aria-hidden="true" />
    </button>
  );
}